










































































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import DraggableIcon from './DraggableIcon.vue';
import dayjs from 'dayjs';
import { DateOrString } from '@/jbi-shared/types/full-document-revision-object.types';
import { GroupLevelAttributeValue } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import AttributeActionButtons from './AttributeActionButtons.vue';

@Component({
  components: {
    DraggableIcon,
    AttributeActionButtons
  }
})
export default class GroupLevelAttributeDateField extends Vue {
  @Prop() attributeValue!: GroupLevelAttributeValue;
  @Prop() fieldClasses!: any;
  @Prop() duplicationError!: boolean;
  @Prop({ default: false }) isSettings!: boolean;
  @Prop({ default: false }) overrideDisableDraggable!: boolean;
  @Prop({ default: false }) overrideDisableAttributeButton!: boolean;
  @Prop() deleteAttribute!: () => void;
  @Prop() updateAttributeValue!: (attribute: GroupLevelAttributeValue) => void;
  @Prop() toggleAttributeRequire!: (
    attribute: GroupLevelAttributeValue
  ) => void;
  @Prop() editAttribute!: (attribute: GroupLevelAttributeValue) => void;
  @Prop() minDate!: DateOrString;
  @Prop() maxDate!: DateOrString;

  fieldErrorMsg: string = '';
  dateValue: Date | null = null;

  // Computed property so changes from the value from parent component are synced
  get isRequired() {
    return this.attributeValue.groupLevelAttributeSpec.isRequired;
  }

  mounted() {
    if (this.attributeValue.value) {
      this.dateValue = dayjs(this.attributeValue.value as string).toDate();
    }
  }

  clearDate() {
    this.dateValue = null;
    this.attributeValue.value = null;
  }

  formatDate(date: Date) {
    this.dateValue = dayjs(date).toDate();
  }

  displayDate(): string {
    return dayjs(this.dateValue as Date).format('DD MMM YYYY');
  }

  @Watch('dateValue')
  assignDateValue() {
    const valueToReturn = this.dateValue
      ? dayjs(this.dateValue).toISOString()
      : null;

    // Update the attribute value
    this.attributeValue.value = valueToReturn;

    if (this.attributeValue.label === 'Start Date') {
      this.returnStartDate();
    }

    if (this.attributeValue.label === 'End Date') {
      this.returnEndDate();
    }
  }

  /**
   * Add a separate watcher for "hasDuplicationError" property
   * because this property is updated by parent.
   */
  @Watch('duplicationError')
  duplicationCallback(currentError: boolean, previousError: boolean): void {
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('isRequired', { immediate: true })
  updateErrorState() {
    if (this.attributeValue.value) {
      this.validateRequiredFieldValues();
      return;
    }

    this.attributeValue.hasFieldError = this.isRequired;
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('attributeValue.value')
  validateRequiredFieldValues() {
    if (
      this.attributeValue.groupLevelAttributeSpec.isRequired &&
      !this.attributeValue.value
    ) {
      this.fieldErrorMsg = `${this.attributeValue.label} is required.`;
      this.attributeValue.hasFieldError = true;
      this.updateAttributeValue(this.attributeValue);
      return;
    }

    this.fieldErrorMsg = '';
    this.attributeValue.hasFieldError = false;
    this.updateAttributeValue(this.attributeValue);
  }

  @Emit('start-date')
  returnStartDate() {
    return this.dateValue;
  }

  @Emit('end-date')
  returnEndDate() {
    return this.dateValue;
  }
}
